/** The model sees this. The visitor line and the admin transcript do not. */
export const PDF_GROUNDING_RULE =
  '[PDF RULE: Answer only from the PDF text above. If it is not written there, say it is not in the file. Do not invent a process.]'

const PDF_CONTENT = /\[PDF CONTENT:[\s\S]*?\]/gi
const PDF_RULE = /\[PDF RULE:[^\]]*\]/gi

/** Admin and chat display: filename or caption, plus vedlegg. Never the raw file body. */
export function presentAttachmentTranscript(text: string): string {
  if (!/\[PDF CONTENT:/i.test(text) && !/\[PDF RULE:/i.test(text)) return text.trim()
  const caption = text.replace(PDF_RULE, '').replace(PDF_CONTENT, '').replace(/\n{2,}/g, '\n').trim()
  const named = caption.match(/[^\s/\\]+\.pdf\b/i)?.[0]
  if (named && caption === named) return `${named} · vedlegg`
  if (caption) return `${caption}\nvedlegg`
  return 'vedlegg'
}
